/**
 * The "All <thing>" + one-option-per-state `<select>` that heads a list
 * page's filter row (postal reservations, returns, …). `value=""` means
 * unfiltered; `onChange` always receives either `""` or one of `options`.
 */
export function StateFilterSelect<T extends string>({
  value,
  onChange,
  options,
  allLabel = "All statuses",
}: {
  value: T | "";
  onChange: (value: T | "") => void;
  options: readonly T[];
  allLabel?: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as T | "")}
      className="flex h-9 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <option value="">{allLabel}</option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  );
}
